import { render } from "./CardOrdersQuoting.vue?vue&type=template&id=65ede4c4"
import script from "./CardOrdersQuoting.vue?vue&type=script&lang=js"
export * from "./CardOrdersQuoting.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__